import { AuthService } from './../../../core/services/auth.service';

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';
import { passwordStrength } from 'check-password-strength';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  newPasswordAgain: any;
  newPassword: any;
  otp: any;
  email: any;
  otp2 = this.fb.control(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
  newPassword2 = this.fb.control(null, [Validators.required]);
  newPasswordAgain2 = this.fb.control(null, [Validators.required]);
  form: FormGroup = this.fb.group({
    otp2: this.otp2,
    newPassword2: this.newPassword2,
    newPasswordAgain2: this.newPasswordAgain2
  });
  hide = true;
  submitData = {
    emailId: '',
    newPassword: '',
    otp: null
  };

  showStrength: boolean = false;
  passwordStrength: string = "Weak";
  color: string = "red";
  samePwd: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.email = sessionStorage.getItem('user');
    sessionStorage.removeItem('user');
  }


  onSubmit() {
    if (this.form.valid && this.passwordStrength.toLowerCase() === 'strong') {
      if (this.samePwd) {
        Swal.fire({
          title: 'Processing...'
        });
        Swal.showLoading();
        if (this.newPassword === this.newPasswordAgain) {
          this.submitData.emailId = this.encrypt(this.email);
          this.submitData.otp = this.otp;
          this.submitData.newPassword = this.encrypt(this.newPassword);
          this.authService.resetPassword(this.submitData).subscribe(
            (registerStatus: any) => {
              Swal.close();
              if (registerStatus.status === 200) {
                Swal.fire('', registerStatus.message, 'success').then(() => {
                  this.router.navigate([`login`]);
                });
              }
              else {
                Swal.fire('', registerStatus.message ? registerStatus.message : 'Something went wrong! please try again later', 'error');
              }
            },
            (error: any) => {
              Swal.close();
              Swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        }
        else {
          Swal.close();
          Swal.fire('Password do not match with Confirm Password.', '', 'error');
        }
      }
      else {
        Swal.close();
        if (!this.samePwd) return Swal.fire('Password and Confirm Password don’t match', '', 'error');
        if (this.passwordStrength.toLowerCase() !== 'strong') return Swal.fire('Please provide strong password', '', 'error');
        // swal('Enter all Fields', '', 'error');
      }
    }
    else {
      if (this.form.invalid) {
        Swal.fire('Please fill all the required fields', '', 'error');
       }
       else if (this.passwordStrength.toLowerCase() !== 'strong') {
        Swal.fire('Please provide strong password', '', 'error');
       }
    }
    return
  }

  encrypt(data: any) {
    const keySize = 256;
    const iterations = 100;
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2('vote for NDM', salt, {
      keySize: keySize / 32,
      iterations: iterations
    });
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const encypText = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    const encryptedData = salt.toString() + iv.toString() + encypText.toString();
    return encryptedData;
  }


  checkStrength = (event: any) => {
    if (event.target.value) {
      this.showStrength = true;
      this.passwordStrength = passwordStrength(event.target.value).value;
      if (this.passwordStrength.toLowerCase() === "weak") this.color = "red";
      if (this.passwordStrength.toLowerCase() === "medium") this.color = "orange";
      if (this.passwordStrength.toLowerCase() === "strong") this.color = "green";
    }
    else {
      this.showStrength = true;
      this.passwordStrength = "Weak";
      this.color = "red";
    }
  }

  checkPassword = (event: any) => {
    if (this.form.get('newPasswordAgain2')?.value === this.form.get('newPassword2')?.value) return this.samePwd = true;
    return this.samePwd = false;
  }

}
